import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  createThis2j2avj17cvnv2 as createThis,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  protoOf180f3jzyo7rfj as protoOf,
  Comparable198qfk8pnblz0 as Comparable,
  KtList3hktaavzmj137 as KtList,
  toSet2orjxp16sotqu as toSet,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  isNaNymqb93xtq8w8 as isNaN_0,
  Unit_instanceat14thlj150z as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  contentEquals379bkuxwxaiqz as contentEquals,
  contentHashCode2dpr73siofp13 as contentHashCode,
  StringBuildermazzzhj6kkai as StringBuilder,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  coerceIn10f36k81le1mm as coerceIn,
  minOfmf6w75l7u1a7 as minOf,
  maxOf1m19db8qhkqy5 as maxOf,
} from './kotlin-kotlin-stdlib.mjs';
import {
  _Ratio___init__impl__9mwvn2xyj9fjgana63 as _Ratio___init__impl__9mwvn2,
  isAlmostEquals2e7wogp48cvmj as isAlmostEquals,
  Ratio__toDouble_impl_o7epze2ppsc3gplivz8 as Ratio__toDouble_impl_o7epze,
  umod1d8wj61c81r0q as umod,
  toRatio1hooqit5gulhr as toRatio,
  Ratio__times_impl_ucdh7y2x1w5kf040xma as Ratio__times_impl_ucdh7y,
  Ratio__compareTo_impl_z2iencsp0le8uhwq33 as Ratio__compareTo_impl_z2ienc,
  roundDecimalPlaces1x32iuyd1l8m5 as roundDecimalPlaces,
  get_niceStr3crhxydmlnaoj as get_niceStr,
  isAlmostEquals$default2ib7nwup21mfy as isAlmostEquals$default,
  IsAlmostEquals2vs54x7i426j2 as IsAlmostEquals,
  get_niceStr1tlwtz2l2j4my as get_niceStr_0,
  interpolate35pbs3ac913y4 as interpolate,
} from './korlibs-math-core-root-korlibs-math-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.s3h_1 = Anchor2D.d3i(0.0, 0.0);
    this.t3h_1 = Anchor2D.d3i(0.5, 0.0);
    this.u3h_1 = Anchor2D.d3i(1.0, 0.0);
    this.v3h_1 = Anchor2D.d3i(0.0, 0.5);
    this.w3h_1 = Anchor2D.d3i(0.5, 0.5);
    this.x3h_1 = Anchor2D.d3i(1.0, 0.5);
    this.y3h_1 = Anchor2D.d3i(0.0, 1.0);
    this.z3h_1 = Anchor2D.d3i(0.5, 1.0);
    this.a3i_1 = Anchor2D.d3i(1.0, 1.0);
  }
  e3i() {
    return this.w3h_1;
  }
}
class Anchor2D {
  static f3i(sx, sy) {
    Companion_getInstance();
    var $this = createThis(this);
    $this.b3i_1 = sx;
    $this.c3i_1 = sy;
    return $this;
  }
  static d3i(sx, sy) {
    Companion_getInstance();
    return this.f3i(sx, sy);
  }
  toString() {
    return 'Anchor2D(sx=' + this.b3i_1 + ', sy=' + this.c3i_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.b3i_1);
    result = imul(result, 31) + getNumberHashCode(this.c3i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Anchor2D))
      return false;
    var tmp0_other_with_cast = other instanceof Anchor2D ? other : THROW_CCE();
    if (!equals(this.b3i_1, tmp0_other_with_cast.b3i_1))
      return false;
    if (!equals(this.c3i_1, tmp0_other_with_cast.c3i_1))
      return false;
    return true;
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_0 = this;
    var tmp = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio = toRatio(1.0E-5);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio, 6.283185307179586);
    tmp.h3i_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_0 = toRatio(0.0);
    var tmp$ret$2 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp_0.i3i_1 = _Angle___init__impl__g23q1m(tmp$ret$2);
    var tmp_1 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_1 = toRatio(0.25);
    var tmp$ret$4 = Ratio__times_impl_ucdh7y(ratio_1, 6.283185307179586);
    tmp_1.j3i_1 = _Angle___init__impl__g23q1m(tmp$ret$4);
    var tmp_2 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_2 = toRatio(0.5);
    var tmp$ret$6 = Ratio__times_impl_ucdh7y(ratio_2, 6.283185307179586);
    tmp_2.k3i_1 = _Angle___init__impl__g23q1m(tmp$ret$6);
    var tmp_3 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_3 = toRatio(0.75);
    var tmp$ret$8 = Ratio__times_impl_ucdh7y(ratio_3, 6.283185307179586);
    tmp_3.l3i_1 = _Angle___init__impl__g23q1m(tmp$ret$8);
    var tmp_4 = this;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    Companion_getInstance_0();
    var ratio_4 = toRatio(1.0);
    var tmp$ret$10 = Ratio__times_impl_ucdh7y(ratio_4, 6.283185307179586);
    tmp_4.m3i_1 = _Angle___init__impl__g23q1m(tmp$ret$10);
  }
}
class Angle {
  constructor(radians) {
    Companion_getInstance_0();
    this.g3i_1 = radians;
  }
  n3i(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt(this.g3i_1, other, epsilon);
  }
  f27(other, epsilon) {
    return Angle__isAlmostEquals_impl_201sgt_0(this, other, epsilon);
  }
  o3i(other) {
    return Angle__compareTo_impl_a0hfds(this.g3i_1, other);
  }
  d(other) {
    return Angle__compareTo_impl_a0hfds_0(this, other);
  }
  toString() {
    return Angle__toString_impl_786qky(this.g3i_1);
  }
  hashCode() {
    return Angle__hashCode_impl_szcndt(this.g3i_1);
  }
  equals(other) {
    return Angle__equals_impl_zcf5mt(this.g3i_1, other);
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_1 = this;
    this.k3j_1 = _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_10().o3j());
  }
  p3j() {
    return this.k3j_1;
  }
  q3j(p1, p2, p3, p4) {
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_10().t3j(Companion_getInstance_15().r3j(p1, p2, p3, p4), Companion_getInstance_15().s3j(p1, p2, p3, p4)));
  }
}
class BoundsBuilder {
  constructor(bounds) {
    Companion_getInstance_1();
    this.c3k_1 = bounds;
  }
  toString() {
    return BoundsBuilder__toString_impl_fmvxh7(this.c3k_1);
  }
  hashCode() {
    return BoundsBuilder__hashCode_impl_649zbo(this.c3k_1);
  }
  equals(other) {
    return BoundsBuilder__equals_impl_jngfjs(this.c3k_1, other);
  }
}
class Companion_2 {}
class Circle {
  constructor(center, radius) {
    this.d3k_1 = center;
    this.e3k_1 = radius;
  }
  f3k() {
    return this.e3k_1 * this.e3k_1;
  }
  g3k(p) {
    return Companion_getInstance_15().h3k(p, this.d3k_1);
  }
  i3k(p) {
    return this.g3k(p) - this.f3k();
  }
  j3k(p) {
    return this.g3k(p) + this.f3k();
  }
  toString() {
    return 'Circle(center=' + this.d3k_1.toString() + ', radius=' + this.e3k_1 + ')';
  }
  hashCode() {
    var result = this.d3k_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.e3k_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Circle))
      return false;
    var tmp0_other_with_cast = other instanceof Circle ? other : THROW_CCE();
    if (!this.d3k_1.equals(tmp0_other_with_cast.d3k_1))
      return false;
    if (!equals(this.e3k_1, tmp0_other_with_cast.e3k_1))
      return false;
    return true;
  }
}
class IPointList$Sublist$listIterator$1 {
  constructor($index, this$0) {
    this.l3k_1 = $index;
    this.m3k_1 = this$0;
    this.k3k_1 = $index;
  }
  c1() {
    return this.k3k_1 >= this.m3k_1.q3k_1;
  }
  e7() {
    return this.k3k_1 > this.l3k_1;
  }
  d1() {
    var _unary__edvuaz = this.k3k_1;
    this.k3k_1 = _unary__edvuaz + 1 | 0;
    return this.m3k_1.h1(_unary__edvuaz);
  }
  f7() {
    return this.k3k_1 + 1 | 0;
  }
  g7() {
    this.k3k_1 = this.k3k_1 - 1 | 0;
    return this.m3k_1.h1(this.k3k_1);
  }
}
class Sublist {
  constructor(list, fromIndex, toIndex) {
    this.n3k_1 = list;
    this.o3k_1 = fromIndex;
    this.p3k_1 = toIndex;
    this.q3k_1 = this.p3k_1 - this.o3k_1 | 0;
  }
  g1() {
    return this.q3k_1;
  }
  h1(index) {
    return this.n3k_1.h1(index + this.o3k_1 | 0);
  }
  j1() {
    return this.q3k_1 === 0;
  }
  b1() {
    return this.b3();
  }
  b3() {
    return this.k1(0);
  }
  k1(index) {
    return new IPointList$Sublist$listIterator$1(index, this);
  }
  q1(fromIndex, toIndex) {
    return new Sublist(this.n3k_1, this.o3k_1 + fromIndex | 0, this.o3k_1 + toIndex | 0);
  }
  r3k(element) {
    return Companion_instance_3.s3k(this.n3k_1, element, this.o3k_1, this.p3k_1, -this.o3k_1 | 0);
  }
  t3k(elements) {
    return Companion_instance_3.u3k(this, elements);
  }
  a3(elements) {
    return this.t3k(elements);
  }
  v3k(element) {
    return this.r3k(element) >= 0;
  }
  z2(element) {
    if (!(element instanceof Vector2D))
      return false;
    return this.v3k(element instanceof Vector2D ? element : THROW_CCE());
  }
}
class Companion_3 {
  u3k(_this__u8e3s4, elements) {
    var s = toSet(elements);
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(_this__u8e3s4, Collection)) {
        tmp = _this__u8e3s4.j1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = _this__u8e3s4.b1();
      while (tmp0_iterator.c1()) {
        var element = tmp0_iterator.d1();
        // Inline function 'korlibs.math.geom.Companion.containsAllSet.<anonymous>' call
        if (!s.z2(element)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    return tmp$ret$0;
  }
  s3k(list, element, fromIndex, toIndex, offset) {
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        if (list.w3k(n) === element.r3i_1 && list.x3k(n) === element.s3i_1)
          return n + offset | 0;
      }
       while (inductionVariable < toIndex);
    return -1;
  }
}
class IDoubleVectorList {}
function isAlmostEquals_0(other, epsilon) {
  if (!(this.g1() === other.g1()))
    return false;
  if (!(this.b3l() === other.b3l()))
    return false;
  var inductionVariable = 0;
  var last = this.b3l();
  if (inductionVariable < last)
    do {
      var dim = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = this.g1();
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!isAlmostEquals(this.z3k(n, dim), other.z3k(n, dim), epsilon))
            return false;
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return true;
}
class IPointList {}
function get(index) {
  return Vector2D.y3k(this.w3k(index), this.x3k(index));
}
function containsAll(elements) {
  return Companion_instance_3.u3k(this, elements);
}
function iterator() {
  return this.b3();
}
function listIterator() {
  return this.k1(0);
}
function listIterator_0(index) {
  return (new Sublist(this, 0, this.g1())).k1(index);
}
function subList(fromIndex, toIndex) {
  return new Sublist(this, fromIndex, toIndex);
}
class Companion_4 {
  constructor() {
    Companion_instance_4 = this;
    this.c3l_1 = Line2D.g3l(Companion_getInstance_15().t3i_1, Companion_getInstance_15().t3i_1);
    this.d3l_1 = Line2D.g3l(Companion_getInstance_15().u3i_1, Companion_getInstance_15().u3i_1);
  }
}
class Line2D {
  static g3l(a, b) {
    Companion_getInstance_4();
    var $this = createThis(this);
    $this.e3l_1 = a;
    $this.f3l_1 = b;
    return $this;
  }
  static h3l() {
    Companion_getInstance_4();
    return this.g3l(Vector2D.i3l(), Vector2D.i3l());
  }
  static j3l(x0, y0, x1, y1) {
    Companion_getInstance_4();
    return this.g3l(Vector2D.k3l(x0, y0), Vector2D.k3l(x1, y1));
  }
  l3l() {
    return this.e3l_1.r3i_1;
  }
  m3l() {
    return this.e3l_1.s3i_1;
  }
  n3l() {
    return this.f3l_1.r3i_1;
  }
  o3l() {
    return this.f3l_1.s3i_1;
  }
  toString() {
    return 'Line(' + this.e3l_1.toString() + ', ' + this.f3l_1.toString() + ')';
  }
  hashCode() {
    var result = this.e3l_1.hashCode();
    result = imul(result, 31) + this.f3l_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Line2D))
      return false;
    var tmp0_other_with_cast = other instanceof Line2D ? other : THROW_CCE();
    if (!this.e3l_1.equals(tmp0_other_with_cast.e3l_1))
      return false;
    if (!this.f3l_1.equals(tmp0_other_with_cast.f3l_1))
      return false;
    return true;
  }
}
class Companion_5 {
  constructor() {
    Companion_instance_5 = this;
    this.p3l_1 = MarginInt.u3l(0, 0, 0, 0);
  }
}
class MarginInt {
  static u3l(top, right, bottom, left) {
    Companion_getInstance_5();
    var $this = createThis(this);
    $this.q3l_1 = top;
    $this.r3l_1 = right;
    $this.s3l_1 = bottom;
    $this.t3l_1 = left;
    return $this;
  }
  static v3l(margin) {
    Companion_getInstance_5();
    return this.u3l(margin, margin, margin, margin);
  }
  w3l() {
    return !(this.q3l_1 === 0) || !(this.t3l_1 === 0) || !(this.r3l_1 === 0) || !(this.s3l_1 === 0);
  }
  x3l() {
    return this.t3l_1 + this.r3l_1 | 0;
  }
  y3l() {
    return this.q3l_1 + this.s3l_1 | 0;
  }
  toString() {
    return 'MarginInt(top=' + this.q3l_1 + ', right=' + this.r3l_1 + ', bottom=' + this.s3l_1 + ', left=' + this.t3l_1 + ')';
  }
  hashCode() {
    var result = this.q3l_1;
    result = imul(result, 31) + this.r3l_1 | 0;
    result = imul(result, 31) + this.s3l_1 | 0;
    result = imul(result, 31) + this.t3l_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MarginInt))
      return false;
    var tmp0_other_with_cast = other instanceof MarginInt ? other : THROW_CCE();
    if (!(this.q3l_1 === tmp0_other_with_cast.q3l_1))
      return false;
    if (!(this.r3l_1 === tmp0_other_with_cast.r3l_1))
      return false;
    if (!(this.s3l_1 === tmp0_other_with_cast.s3l_1))
      return false;
    if (!(this.t3l_1 === tmp0_other_with_cast.t3l_1))
      return false;
    return true;
  }
}
class Companion_6 {
  constructor() {
    Companion_instance_6 = this;
    this.z3l_1 = new Matrix(1.0, 0.0, 0.0, 1.0, 0.0, 0.0);
    this.a3m_1 = new Matrix(NaN, NaN, NaN, NaN, NaN, NaN);
    this.b3m_1 = this.a3m_1;
  }
  c3m() {
    return this.z3l_1;
  }
  d3m(a, b, epsilon) {
    return isAlmostEquals(a.i3m_1, b.i3m_1, epsilon) && isAlmostEquals(a.j3m_1, b.j3m_1, epsilon) && isAlmostEquals(a.e3m_1, b.e3m_1, epsilon) && isAlmostEquals(a.f3m_1, b.f3m_1, epsilon) && isAlmostEquals(a.g3m_1, b.g3m_1, epsilon) && isAlmostEquals(a.h3m_1, b.h3m_1, epsilon);
  }
  k3m(l, r) {
    if (l.g3j())
      return r;
    if (r.g3j())
      return l;
    return new Matrix(l.e3m_1 * r.e3m_1 + l.f3m_1 * r.g3m_1, l.e3m_1 * r.f3m_1 + l.f3m_1 * r.h3m_1, l.g3m_1 * r.e3m_1 + l.h3m_1 * r.g3m_1, l.g3m_1 * r.f3m_1 + l.h3m_1 * r.h3m_1, l.i3m_1 * r.e3m_1 + l.j3m_1 * r.g3m_1 + r.i3m_1, l.i3m_1 * r.f3m_1 + l.j3m_1 * r.h3m_1 + r.j3m_1);
  }
  l3m(x, y, rotation, scaleX, scaleY, skewX, skewY, pivotX, pivotY) {
    // Inline function 'korlibs.math.geom.cos' call
    var angle = Angle__plus_impl_26v37k(rotation, skewY);
    var up = Companion_getInstance_15().x3i_1;
    var a = Angle__cosine_impl_bgvzun(angle, up) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_0 = Angle__plus_impl_26v37k(rotation, skewY);
    var up_0 = Companion_getInstance_15().x3i_1;
    var b = Angle__sine_impl_3l11xv(angle_0, up_0) * scaleX + 0.0;
    // Inline function 'korlibs.math.geom.sin' call
    var angle_1 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_1 = Companion_getInstance_15().x3i_1;
    var c = -Angle__sine_impl_3l11xv(angle_1, up_1) * scaleY + 0.0;
    // Inline function 'korlibs.math.geom.cos' call
    var angle_2 = Angle__minus_impl_xeau7k(rotation, skewX);
    var up_2 = Companion_getInstance_15().x3i_1;
    var d = Angle__cosine_impl_bgvzun(angle_2, up_2) * scaleY + 0.0;
    var tx;
    var ty;
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = x;
      ty = y;
    } else {
      tx = x - (pivotX * a + pivotY * c);
      ty = y - (pivotX * b + pivotY * d);
    }
    return new Matrix(a, b, c, d, tx, ty);
  }
  m3m(a, b, c, d, tx, ty, p) {
    return Vector2D.y3k(a * p.r3i_1 + c * p.s3i_1 + tx, d * p.s3i_1 + b * p.r3i_1 + ty);
  }
}
class Matrix {
  constructor(a, b, c, d, tx, ty) {
    Companion_getInstance_6();
    tx = tx === VOID ? 0.0 : tx;
    ty = ty === VOID ? 0.0 : ty;
    this.e3m_1 = a;
    this.f3m_1 = b;
    this.g3m_1 = c;
    this.h3m_1 = d;
    this.i3m_1 = tx;
    this.j3m_1 = ty;
  }
  n3m(other) {
    return Companion_getInstance_6().k3m(this, other);
  }
  g3j() {
    return isNaN_0(this.e3m_1);
  }
  h3j() {
    return !this.g3j();
  }
  o3m() {
    return this.e3m_1 === 1.0 && this.f3m_1 === 0.0 && this.g3m_1 === 0.0 && this.h3m_1 === 1.0 && this.i3m_1 === 0.0 && this.j3m_1 === 0.0;
  }
  p3m() {
    var hasRotation = !(this.f3m_1 === 0.0) || !(this.g3m_1 === 0.0);
    var hasScale = !(this.e3m_1 === 1.0) || !(this.h3m_1 === 1.0);
    var hasTranslation = !(this.i3m_1 === 0.0) || !(this.j3m_1 === 0.0);
    return hasRotation ? MatrixType_COMPLEX_getInstance() : hasScale && hasTranslation ? MatrixType_SCALE_TRANSLATE_getInstance() : hasScale ? MatrixType_SCALE_getInstance() : hasTranslation ? MatrixType_TRANSLATE_getInstance() : MatrixType_IDENTITY_getInstance();
  }
  q3m(p) {
    return this.r3m(p.r3i_1, p.s3i_1);
  }
  s3m(x, y) {
    return this.r3m(x, y);
  }
  t3m(x, y) {
    return this.u3m(x, y);
  }
  r3m(x, y) {
    return this.e3m_1 * x + this.g3m_1 * y + this.i3m_1;
  }
  u3m(x, y) {
    return this.h3m_1 * y + this.f3m_1 * x + this.j3m_1;
  }
  v3m(angle) {
    // Inline function 'korlibs.math.geom.cos' call
    var up = Companion_getInstance_15().x3i_1;
    var cos = Angle__cosine_impl_bgvzun(angle, up);
    // Inline function 'korlibs.math.geom.sin' call
    var up_0 = Companion_getInstance_15().x3i_1;
    var sin = Angle__sine_impl_3l11xv(angle, up_0);
    var a1 = this.e3m_1 * cos - this.f3m_1 * sin;
    var b = this.e3m_1 * sin + this.f3m_1 * cos;
    var a = a1;
    var c1 = this.g3m_1 * cos - this.h3m_1 * sin;
    var d = this.g3m_1 * sin + this.h3m_1 * cos;
    var c = c1;
    var tx1 = this.i3m_1 * cos - this.j3m_1 * sin;
    var ty = this.i3m_1 * sin + this.j3m_1 * cos;
    var tx = tx1;
    return new Matrix(a, b, c, d, tx, ty);
  }
  w3m(scaleX, scaleY) {
    return this.x3m(scaleX, scaleY);
  }
  x3m(scaleX, scaleY) {
    return new Matrix(this.e3m_1 * scaleX, this.f3m_1 * scaleX, this.g3m_1 * scaleY, this.h3m_1 * scaleY, this.i3m_1 * scaleX, this.j3m_1 * scaleY);
  }
  y3m(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.x3m(scaleX, scaleY) : $super.x3m.call(this, scaleX, scaleY);
  }
  z3m(scaleX, scaleY) {
    return new Matrix(this.e3m_1 * scaleX, this.f3m_1 * scaleX, this.g3m_1 * scaleY, this.h3m_1 * scaleY, this.i3m_1, this.j3m_1);
  }
  a3n(scaleX, scaleY, $super) {
    scaleY = scaleY === VOID ? scaleX : scaleY;
    return $super === VOID ? this.z3m(scaleX, scaleY) : $super.z3m.call(this, scaleX, scaleY);
  }
  b3n(delta) {
    return new Matrix(this.e3m_1, this.f3m_1, this.g3m_1, this.h3m_1, this.i3m_1 + delta.r3i_1, this.j3m_1 + delta.s3i_1);
  }
  c3n(x, y) {
    return this.b3n(Vector2D.k3l(x, y));
  }
  d3n(x, y) {
    return this.b3n(Vector2D.y3k(x, y));
  }
  e3n(delta) {
    return new Matrix(this.e3m_1, this.f3m_1, this.g3m_1, this.h3m_1, this.i3m_1 + (this.e3m_1 * delta.r3i_1 + this.g3m_1 * delta.s3i_1), this.j3m_1 + (this.f3m_1 * delta.r3i_1 + this.h3m_1 * delta.s3i_1));
  }
  f3n(deltaX, deltaY) {
    return this.e3n(Vector2D.y3k(deltaX, deltaY));
  }
  g3n(m) {
    return m.n3m(this);
  }
  h3n() {
    if (this.g3j())
      return Companion_getInstance_6().z3l_1;
    var m = this;
    var norm = m.e3m_1 * m.h3m_1 - m.f3m_1 * m.g3m_1;
    var tmp;
    if (norm === 0.0) {
      tmp = new Matrix(0.0, 0.0, 0.0, 0.0, -m.i3m_1, -m.j3m_1);
    } else {
      var inorm = 1.0 / norm;
      var d = m.e3m_1 * inorm;
      var a = m.h3m_1 * inorm;
      var b = m.f3m_1 * -inorm;
      var c = m.g3m_1 * -inorm;
      tmp = new Matrix(a, b, c, d, -a * m.i3m_1 - c * m.j3m_1, -b * m.i3m_1 - d * m.j3m_1);
    }
    return tmp;
  }
  i3n() {
    return this.j3n();
  }
  j3n() {
    return Companion_getInstance_7().l3n(this);
  }
  toString() {
    return 'Matrix(' + get_niceStr(this.e3m_1) + ', ' + get_niceStr(this.f3m_1) + ', ' + get_niceStr(this.g3m_1) + ', ' + get_niceStr(this.h3m_1) + ', ' + get_niceStr(this.i3m_1) + ', ' + get_niceStr(this.j3m_1) + ')';
  }
  m3n(other, epsilon) {
    return Companion_getInstance_6().d3m(this, other, epsilon);
  }
  f27(other, epsilon) {
    return this.m3n(other instanceof Matrix ? other : THROW_CCE(), epsilon);
  }
  n3n(other) {
    return this.n3m(other);
  }
  hashCode() {
    var result = getNumberHashCode(this.e3m_1);
    result = imul(result, 31) + getNumberHashCode(this.f3m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g3m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h3m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i3m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j3m_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Matrix))
      return false;
    var tmp0_other_with_cast = other instanceof Matrix ? other : THROW_CCE();
    if (!equals(this.e3m_1, tmp0_other_with_cast.e3m_1))
      return false;
    if (!equals(this.f3m_1, tmp0_other_with_cast.f3m_1))
      return false;
    if (!equals(this.g3m_1, tmp0_other_with_cast.g3m_1))
      return false;
    if (!equals(this.h3m_1, tmp0_other_with_cast.h3m_1))
      return false;
    if (!equals(this.i3m_1, tmp0_other_with_cast.i3m_1))
      return false;
    if (!equals(this.j3m_1, tmp0_other_with_cast.j3m_1))
      return false;
    return true;
  }
}
class MatrixType extends Enum {
  constructor(name, ordinal, id, hasRotation, hasScale, hasTranslation) {
    super(name, ordinal);
    this.q3n_1 = id;
    this.r3n_1 = hasRotation;
    this.s3n_1 = hasScale;
    this.t3n_1 = hasTranslation;
  }
}
class Companion_7 {
  constructor() {
    Companion_instance_7 = this;
    this.k3n_1 = MatrixTransform.b3o(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().i3i_1, Companion_getInstance_0().i3i_1, Companion_getInstance_0().i3i_1);
  }
  c3o(matrix, pivotX, pivotY) {
    var a = matrix.e3m_1;
    var b = matrix.f3m_1;
    var c = matrix.g3m_1;
    var d = matrix.h3m_1;
    // Inline function 'kotlin.math.atan2' call
    var y = -c;
    var skewX = -Math.atan2(y, d);
    // Inline function 'kotlin.math.atan2' call
    var skewY = Math.atan2(b, a);
    // Inline function 'kotlin.math.abs' call
    var x = skewX + skewY;
    var delta = Math.abs(x);
    var trotation;
    var tskewX;
    var tskewY;
    var tx;
    var ty;
    var tmp;
    if (delta < 0.001) {
      tmp = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      var x_0 = 3.141592653589793 * 2 - delta;
      tmp = Math.abs(x_0) < 0.001;
    }
    if (tmp) {
      trotation = get_radians_0(skewY);
      tskewX = get_radians_0(0.0);
      tskewY = get_radians_0(0.0);
    } else {
      trotation = get_radians(0);
      tskewX = get_radians_0(skewX);
      tskewY = get_radians_0(skewY);
    }
    // Inline function 'kotlin.math.hypot' call
    var tscaleX = hypot(a, b);
    // Inline function 'kotlin.math.hypot' call
    var tscaleY = hypot(c, d);
    if (pivotX === 0.0 && pivotY === 0.0) {
      tx = matrix.i3m_1;
      ty = matrix.j3m_1;
    } else {
      tx = matrix.i3m_1 + (pivotX * a + pivotY * c);
      ty = matrix.j3m_1 + (pivotX * b + pivotY * d);
    }
    return MatrixTransform.b3o(tx, ty, tscaleX, tscaleY, tskewX, tskewY, trotation);
  }
  l3n(matrix, pivotX, pivotY, $super) {
    pivotX = pivotX === VOID ? 0.0 : pivotX;
    pivotY = pivotY === VOID ? 0.0 : pivotY;
    return $super === VOID ? this.c3o(matrix, pivotX, pivotY) : $super.c3o.call(this, matrix, pivotX, pivotY);
  }
  d3o(a, b, epsilon) {
    return isAlmostEquals(a.u3n_1, b.u3n_1, epsilon) && isAlmostEquals(a.v3n_1, b.v3n_1, epsilon) && isAlmostEquals(a.w3n_1, b.w3n_1, epsilon) && isAlmostEquals(a.x3n_1, b.x3n_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.y3n_1, b.y3n_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.z3n_1, b.z3n_1, epsilon) && Angle__isAlmostEquals_impl_201sgt(a.a3o_1, b.a3o_1, epsilon);
  }
}
class MatrixTransform {
  static b3o(x, y, scaleX, scaleY, skewX, skewY, rotation) {
    Companion_getInstance_7();
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    scaleX = scaleX === VOID ? 1.0 : scaleX;
    scaleY = scaleY === VOID ? 1.0 : scaleY;
    skewX = skewX === VOID ? Companion_getInstance_0().i3i_1 : skewX;
    skewY = skewY === VOID ? Companion_getInstance_0().i3i_1 : skewY;
    rotation = rotation === VOID ? Companion_getInstance_0().i3i_1 : rotation;
    var $this = createThis(this);
    $this.u3n_1 = x;
    $this.v3n_1 = y;
    $this.w3n_1 = scaleX;
    $this.x3n_1 = scaleY;
    $this.y3n_1 = skewX;
    $this.z3n_1 = skewY;
    $this.a3o_1 = rotation;
    return $this;
  }
  toString() {
    return 'MatrixTransform(x=' + get_niceStr(this.u3n_1) + ', y=' + get_niceStr(this.v3n_1) + ', scaleX=' + this.w3n_1 + ', scaleY=' + this.x3n_1 + ', skewX=' + Angle__toString_impl_786qky(this.y3n_1) + ', skewY=' + Angle__toString_impl_786qky(this.z3n_1) + ', rotation=' + Angle__toString_impl_786qky(this.a3o_1) + ')';
  }
  static e3o() {
    Companion_getInstance_7();
    return this.b3o(0.0, 0.0, 1.0, 1.0, Companion_getInstance_0().i3i_1, Companion_getInstance_0().i3i_1, Companion_getInstance_0().i3i_1);
  }
  f3o(other, epsilon) {
    return Companion_getInstance_7().d3o(this, other, epsilon);
  }
  f27(other, epsilon) {
    return this.f3o(other instanceof MatrixTransform ? other : THROW_CCE(), epsilon);
  }
  g3o() {
    return (this.w3n_1 + this.x3n_1) * 0.5;
  }
  hashCode() {
    var result = getNumberHashCode(this.u3n_1);
    result = imul(result, 31) + getNumberHashCode(this.v3n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w3n_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x3n_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.y3n_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.z3n_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.a3o_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof MatrixTransform))
      return false;
    var tmp0_other_with_cast = other instanceof MatrixTransform ? other : THROW_CCE();
    if (!equals(this.u3n_1, tmp0_other_with_cast.u3n_1))
      return false;
    if (!equals(this.v3n_1, tmp0_other_with_cast.v3n_1))
      return false;
    if (!equals(this.w3n_1, tmp0_other_with_cast.w3n_1))
      return false;
    if (!equals(this.x3n_1, tmp0_other_with_cast.x3n_1))
      return false;
    if (!equals(this.y3n_1, tmp0_other_with_cast.y3n_1))
      return false;
    if (!equals(this.z3n_1, tmp0_other_with_cast.z3n_1))
      return false;
    if (!equals(this.a3o_1, tmp0_other_with_cast.a3o_1))
      return false;
    return true;
  }
}
class Companion_8 {
  constructor() {
    Companion_instance_8 = this;
    this.h3o_1 = 0;
    this.i3o_1 = 1;
    this.j3o_1 = 2;
    this.k3o_1 = 3;
    this.l3o_1 = 4;
    this.m3o_1 = 5;
    this.n3o_1 = 6;
    this.o3o_1 = 7;
    this.p3o_1 = 8;
    this.q3o_1 = 9;
    this.r3o_1 = 10;
    this.s3o_1 = 11;
    this.t3o_1 = 12;
    this.u3o_1 = 13;
    this.v3o_1 = 14;
    this.w3o_1 = 15;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp.x3o_1 = new Int32Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
    var tmp_0 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_0.y3o_1 = new Int32Array([0, 4, 8, 12, 1, 5, 9, 13, 2, 6, 10, 14, 3, 7, 11, 15]);
    var tmp_1 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_1.z3o_1 = new Int32Array([0, 1, 2, 4, 5, 6, 8, 9, 10]);
    var tmp_2 = this;
    // Inline function 'kotlin.intArrayOf' call
    tmp_2.a3p_1 = new Int32Array([0, 4, 8, 1, 5, 9, 2, 6, 10]);
    this.b3p_1 = Matrix4.d3p();
  }
  e3p(v00, v01, v02, v03, v10, v11, v12, v13, v20, v21, v22, v23, v30, v31, v32, v33) {
    return Matrix4.f3p(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33);
  }
  g3p(l, r) {
    return Companion_getInstance_8().e3p(l.h3p() * r.h3p() + l.i3p() * r.j3p() + l.k3p() * r.l3p() + l.m3p() * r.n3p(), l.h3p() * r.i3p() + l.i3p() * r.o3p() + l.k3p() * r.p3p() + l.m3p() * r.q3p(), l.h3p() * r.k3p() + l.i3p() * r.r3p() + l.k3p() * r.s3p() + l.m3p() * r.t3p(), l.h3p() * r.m3p() + l.i3p() * r.u3p() + l.k3p() * r.v3p() + l.m3p() * r.w3p(), l.j3p() * r.h3p() + l.o3p() * r.j3p() + l.r3p() * r.l3p() + l.u3p() * r.n3p(), l.j3p() * r.i3p() + l.o3p() * r.o3p() + l.r3p() * r.p3p() + l.u3p() * r.q3p(), l.j3p() * r.k3p() + l.o3p() * r.r3p() + l.r3p() * r.s3p() + l.u3p() * r.t3p(), l.j3p() * r.m3p() + l.o3p() * r.u3p() + l.r3p() * r.v3p() + l.u3p() * r.w3p(), l.l3p() * r.h3p() + l.p3p() * r.j3p() + l.s3p() * r.l3p() + l.v3p() * r.n3p(), l.l3p() * r.i3p() + l.p3p() * r.o3p() + l.s3p() * r.p3p() + l.v3p() * r.q3p(), l.l3p() * r.k3p() + l.p3p() * r.r3p() + l.s3p() * r.s3p() + l.v3p() * r.t3p(), l.l3p() * r.m3p() + l.p3p() * r.u3p() + l.s3p() * r.v3p() + l.v3p() * r.w3p(), l.n3p() * r.h3p() + l.q3p() * r.j3p() + l.t3p() * r.l3p() + l.w3p() * r.n3p(), l.n3p() * r.i3p() + l.q3p() * r.o3p() + l.t3p() * r.p3p() + l.w3p() * r.q3p(), l.n3p() * r.k3p() + l.q3p() * r.r3p() + l.t3p() * r.s3p() + l.w3p() * r.t3p(), l.n3p() * r.m3p() + l.q3p() * r.u3p() + l.t3p() * r.v3p() + l.w3p() * r.w3p());
  }
  x3p(left, right, bottom, top, near, far) {
    var sx = 2.0 / (right - left);
    var sy = 2.0 / (top - bottom);
    var sz = -2.0 / (far - near);
    var tx = -(right + left) / (right - left);
    var ty = -(top + bottom) / (top - bottom);
    var tz = -(far + near) / (far - near);
    return Companion_getInstance_8().e3p(sx, 0.0, 0.0, tx, 0.0, sy, 0.0, ty, 0.0, 0.0, sz, tz, 0.0, 0.0, 0.0, 1.0);
  }
  y3p(left, right, bottom, top, near, far) {
    return this.x3p(left, right, bottom, top, near, far);
  }
}
class Matrix4 {
  static z3p(data) {
    Companion_getInstance_8();
    var $this = createThis(this);
    $this.c3p_1 = data;
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!($this.c3p_1.length === 16)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.h5(toString(message));
    }
    return $this;
  }
  h3p() {
    return this.c3p_1[0];
  }
  j3p() {
    return this.c3p_1[1];
  }
  l3p() {
    return this.c3p_1[2];
  }
  n3p() {
    return this.c3p_1[3];
  }
  i3p() {
    return this.c3p_1[4];
  }
  o3p() {
    return this.c3p_1[5];
  }
  p3p() {
    return this.c3p_1[6];
  }
  q3p() {
    return this.c3p_1[7];
  }
  k3p() {
    return this.c3p_1[8];
  }
  r3p() {
    return this.c3p_1[9];
  }
  s3p() {
    return this.c3p_1[10];
  }
  t3p() {
    return this.c3p_1[11];
  }
  m3p() {
    return this.c3p_1[12];
  }
  u3p() {
    return this.c3p_1[13];
  }
  v3p() {
    return this.c3p_1[14];
  }
  w3p() {
    return this.c3p_1[15];
  }
  equals(other) {
    var tmp;
    if (other instanceof Matrix4) {
      tmp = contentEquals(this.c3p_1, other.c3p_1);
    } else {
      tmp = false;
    }
    return tmp;
  }
  hashCode() {
    return contentHashCode(this.c3p_1);
  }
  a3q(that) {
    return Companion_getInstance_8().g3p(this, that);
  }
  static f3p(v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33) {
    Companion_getInstance_8();
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([v00, v10, v20, v30, v01, v11, v21, v31, v02, v12, v22, v32, v03, v13, v23, v33]);
    return this.z3p(tmp$ret$0);
  }
  static d3p() {
    Companion_getInstance_8();
    return this.f3p(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
  }
  z3k(row, column) {
    if (!(0 <= column ? column <= 3 : false) || !(0 <= row ? row <= 3 : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + row + ',' + column;
      throw IllegalStateException.h5(toString(message));
    }
    return this.c3p_1[imul(row, 4) + column | 0];
  }
  b3q(index) {
    if (!(0 <= index ? index <= (this.c3p_1.length - 1 | 0) : false)) {
      // Inline function 'kotlin.error' call
      var message = 'Invalid index ' + index;
      throw IllegalStateException.h5(toString(message));
    }
    return this.c3p_1[index];
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.f();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.math.geom.Matrix4.toString.<anonymous>' call
    this_0.gc('Matrix4(\n');
    var inductionVariable = 0;
    if (inductionVariable < 4)
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this_0.gc('  [ ');
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < 4)
          do {
            var col = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            if (!(col === 0)) {
              this_0.gc(', ');
            }
            var v = this.z3k(row, col);
            // Inline function 'kotlin.math.floor' call
            if (Math.floor(v) === v)
              this_0.rh(numberToInt(v));
            else {
              this_0.th(v);
            }
          }
           while (inductionVariable_0 < 4);
        this_0.gc(' ],\n');
      }
       while (inductionVariable < 4);
    this_0.gc(')');
    return this_0.toString();
  }
}
class Companion_9 {
  constructor() {
    this.p3i_1 = 1.0E-7;
  }
  q3i(up) {
    // Inline function 'kotlin.check' call
    var tmp;
    if (up.r3i_1 === 0.0) {
      // Inline function 'kotlin.math.absoluteValue' call
      var this_0 = up.s3i_1;
      tmp = Math.abs(this_0) === 1.0;
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp) {
      // Inline function 'korlibs.math.geom.Companion.checkValidUpVector.<anonymous>' call
      var message = 'up vector only supports (0, -1) and (0, +1) for now';
      throw IllegalStateException.h5(toString(message));
    }
  }
}
class Orientation extends Enum {
  constructor(name, ordinal, value) {
    super(name, ordinal);
    this.j3q_1 = value;
  }
}
class Companion_10 {
  constructor() {
    Companion_instance_10 = this;
    this.l3j_1 = Companion_getInstance_10().k3q(0, 0, 0, 0);
    this.m3j_1 = Companion_getInstance_10().l3q(-Infinity, -Infinity, Infinity, Infinity);
    this.n3j_1 = Companion_getInstance_10().l3q(NaN, NaN, 0.0, 0.0);
  }
  o3j() {
    return this.n3j_1;
  }
  c3m() {
    return this.l3j_1;
  }
  x3j(p, s) {
    return new Rectangle(p.r3i_1, p.s3i_1, s.u3j_1, s.v3j_1);
  }
  k3q(x, y, width, height) {
    return Companion_getInstance_10().x3j(Vector2D.k3l(x, y), Size2D.w3j(width, height));
  }
  l3q(x, y, width, height) {
    return Companion_getInstance_10().x3j(Vector2D.m3q(x, y), Size2D.n3q(width, height));
  }
  o3q(left, top, right, bottom) {
    return new Rectangle(left, top, right - left, bottom - top);
  }
  p3q(left, top, right, bottom) {
    return this.o3q(left, top, right, bottom);
  }
  t3j(point1, point2) {
    var tmp = Companion_getInstance_10();
    // Inline function 'korlibs.math.geom.Vector2D.minus' call
    var tmp$ret$0 = Vector2D.y3k(point2.r3i_1 - point1.r3i_1, point2.s3i_1 - point1.s3i_1);
    return tmp.x3j(point1, toSize(tmp$ret$0));
  }
  q3q(a, b) {
    return a.b3j_1 >= b.b3j_1 && a.c3j_1 >= b.c3j_1 && a.b3j_1 + a.d3j_1 <= b.b3j_1 + b.d3j_1 && a.c3j_1 + a.e3j_1 <= b.c3j_1 + b.e3j_1;
  }
}
class Rectangle {
  constructor(x, y, width, height) {
    Companion_getInstance_10();
    this.b3j_1 = x;
    this.c3j_1 = y;
    this.d3j_1 = width;
    this.e3j_1 = height;
    this.f3j_1 = true;
  }
  g1() {
    return Size2D.r3q(this.d3j_1, this.e3j_1);
  }
  s3q() {
    return isNaN_0(this.b3j_1);
  }
  g3j() {
    return this.s3q();
  }
  h3j() {
    return !this.g3j();
  }
  t3q(other, epsilon) {
    return isAlmostEquals(this.b3j_1, other.b3j_1, epsilon) && isAlmostEquals(this.c3j_1, other.c3j_1, epsilon) && isAlmostEquals(this.d3j_1, other.d3j_1, epsilon) && isAlmostEquals(this.e3j_1, other.e3j_1, epsilon);
  }
  f27(other, epsilon) {
    return this.t3q(other instanceof Rectangle ? other : THROW_CCE(), epsilon);
  }
  toString() {
    return this.g3j() ? 'null' : 'Rectangle(x=' + get_niceStr(this.b3j_1) + ', y=' + get_niceStr(this.c3j_1) + ', width=' + get_niceStr(this.d3j_1) + ', height=' + get_niceStr(this.e3j_1) + ')';
  }
  u3q(scale) {
    return new Rectangle(this.b3j_1 * scale, this.c3j_1 * scale, this.d3j_1 * scale, this.e3j_1 * scale);
  }
  v3k(that) {
    return this.v3q(that.r3i_1, that.s3i_1);
  }
  v3q(x, y) {
    return x >= this.i3j() && x < this.j3j() && (y >= this.d3q() && y < this.c3q());
  }
  i3j() {
    return this.b3j_1;
  }
  d3q() {
    return this.c3j_1;
  }
  j3j() {
    return this.b3j_1 + this.d3j_1;
  }
  c3q() {
    return this.c3j_1 + this.e3j_1;
  }
  y3j() {
    return Vector2D.y3k(this.i3j(), this.d3q());
  }
  w3q() {
    return Vector2D.y3k(this.j3j(), this.d3q());
  }
  x3q() {
    return Vector2D.y3k(this.i3j(), this.c3q());
  }
  a3k() {
    return Vector2D.y3k(this.j3j(), this.c3q());
  }
  y3q() {
    return (this.j3j() + this.i3j()) * 0.5;
  }
  z3q() {
    return (this.c3q() + this.d3q()) * 0.5;
  }
  a3r() {
    return Vector2D.y3k(this.y3q(), this.z3q());
  }
  b3r(that) {
    return this.c3r(that) && this.d3r(that);
  }
  c3r(that) {
    return that.i3j() <= this.j3j() && that.j3j() >= this.i3j();
  }
  d3r(that) {
    return that.d3q() <= this.c3q() && that.c3q() >= this.d3q();
  }
  e3r(that) {
    var tmp;
    if (this.b3r(that)) {
      // Inline function 'kotlin.math.max' call
      var a = this.i3j();
      var b = that.i3j();
      var tmp_0 = Math.max(a, b);
      // Inline function 'kotlin.math.max' call
      var a_0 = this.d3q();
      var b_0 = that.d3q();
      var tmp_1 = Math.max(a_0, b_0);
      // Inline function 'kotlin.math.min' call
      var a_1 = this.j3j();
      var b_1 = that.j3j();
      var tmp_2 = Math.min(a_1, b_1);
      // Inline function 'kotlin.math.min' call
      var a_2 = this.c3q();
      var b_2 = that.c3q();
      var tmp$ret$3 = Math.min(a_2, b_2);
      tmp = new Rectangle(tmp_0, tmp_1, tmp_2, tmp$ret$3);
    } else {
      tmp = Companion_getInstance_10().o3j();
    }
    return tmp;
  }
  l2() {
    return RectangleInt.j3r(numberToInt(this.b3j_1), numberToInt(this.c3j_1), numberToInt(this.d3j_1), numberToInt(this.e3j_1));
  }
  k3r(border) {
    return Companion_getInstance_10().o3q(this.i3j() - border.t3l_1, this.d3q() - border.q3l_1, this.j3j() + border.r3l_1, this.c3q() + border.s3l_1);
  }
  b3n(delta) {
    return this.l3r(this.b3j_1 + delta.r3i_1, this.c3j_1 + delta.s3i_1);
  }
  m3r(m) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = this.y3j();
      if (m.g3j()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.y3k(m.r3m(p.r3i_1, p.s3i_1), m.u3m(p.r3i_1, p.s3i_1));
    }
    var tl = tmp$ret$0;
    var tmp$ret$1;
    $l$block_0: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_0 = this.w3q();
      if (m.g3j()) {
        tmp$ret$1 = p_0;
        break $l$block_0;
      }
      tmp$ret$1 = Vector2D.y3k(m.r3m(p_0.r3i_1, p_0.s3i_1), m.u3m(p_0.r3i_1, p_0.s3i_1));
    }
    var tr = tmp$ret$1;
    var tmp$ret$2;
    $l$block_1: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_1 = this.x3q();
      if (m.g3j()) {
        tmp$ret$2 = p_1;
        break $l$block_1;
      }
      tmp$ret$2 = Vector2D.y3k(m.r3m(p_1.r3i_1, p_1.s3i_1), m.u3m(p_1.r3i_1, p_1.s3i_1));
    }
    var bl = tmp$ret$2;
    var tmp$ret$3;
    $l$block_2: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p_2 = this.a3k();
      if (m.g3j()) {
        tmp$ret$3 = p_2;
        break $l$block_2;
      }
      tmp$ret$3 = Vector2D.y3k(m.r3m(p_2.r3i_1, p_2.s3i_1), m.u3m(p_2.r3i_1, p_2.s3i_1));
    }
    var br = tmp$ret$3;
    var min = Companion_getInstance_15().r3j(tl, tr, bl, br);
    var max = Companion_getInstance_15().s3j(tl, tr, bl, br);
    return Companion_getInstance_10().t3j(min, max);
  }
  n3r() {
    return Companion_getInstance_10().t3j(Companion_getInstance_15().z3j(this.y3j(), this.a3k()), Companion_getInstance_15().b3k(this.y3j(), this.a3k()));
  }
  o3r(x, y, width, height) {
    return new Rectangle(x, y, width, height);
  }
  l3r(x, y, width, height, $super) {
    x = x === VOID ? this.b3j_1 : x;
    y = y === VOID ? this.c3j_1 : y;
    width = width === VOID ? this.d3j_1 : width;
    height = height === VOID ? this.e3j_1 : height;
    return $super === VOID ? this.o3r(x, y, width, height) : $super.o3r.call(this, x, y, width, height);
  }
  hashCode() {
    var result = getNumberHashCode(this.b3j_1);
    result = imul(result, 31) + getNumberHashCode(this.c3j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d3j_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e3j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    var tmp0_other_with_cast = other instanceof Rectangle ? other : THROW_CCE();
    if (!equals(this.b3j_1, tmp0_other_with_cast.b3j_1))
      return false;
    if (!equals(this.c3j_1, tmp0_other_with_cast.c3j_1))
      return false;
    if (!equals(this.d3j_1, tmp0_other_with_cast.d3j_1))
      return false;
    if (!equals(this.e3j_1, tmp0_other_with_cast.e3j_1))
      return false;
    return true;
  }
}
class Companion_11 {
  q3r(a, b) {
    // Inline function 'kotlin.math.min' call
    var a_0 = a.i3j();
    var b_0 = b.i3j();
    var tmp = Math.min(a_0, b_0);
    // Inline function 'kotlin.math.min' call
    var a_1 = a.d3q();
    var b_1 = b.d3q();
    var tmp_0 = Math.min(a_1, b_1);
    // Inline function 'kotlin.math.max' call
    var a_2 = a.j3j();
    var b_2 = b.j3j();
    var tmp_1 = Math.max(a_2, b_2);
    // Inline function 'kotlin.math.max' call
    var a_3 = a.c3q();
    var b_3 = b.c3q();
    var tmp$ret$3 = Math.max(a_3, b_3);
    return this.p3q(tmp, tmp_0, tmp_1, tmp$ret$3);
  }
  r3r(topLeft, bottomRight) {
    var size = bottomRight.u3r(topLeft);
    return RectangleInt.j3r(topLeft.s3r_1, topLeft.t3r_1, size.s3r_1, size.t3r_1);
  }
  p3q(left, top, right, bottom) {
    return this.r3r(Vector2I.v3r(left, top), Vector2I.v3r(right, bottom));
  }
}
class RectangleInt {
  static j3r(x, y, width, height) {
    var $this = createThis(this);
    $this.f3r_1 = x;
    $this.g3r_1 = y;
    $this.h3r_1 = width;
    $this.i3r_1 = height;
    return $this;
  }
  static w3r() {
    return this.j3r(0, 0, 0, 0);
  }
  x3r() {
    return imul(this.h3r_1, this.i3r_1);
  }
  i3j() {
    return this.f3r_1;
  }
  d3q() {
    return this.g3r_1;
  }
  j3j() {
    return this.f3r_1 + this.h3r_1 | 0;
  }
  c3q() {
    return this.g3r_1 + this.i3r_1 | 0;
  }
  y3r(left, top, right, bottom, clamped) {
    var left_0 = !clamped ? left : coerceIn(left, 0, this.h3r_1);
    var right_0 = !clamped ? right : coerceIn(right, 0, this.h3r_1);
    var top_0 = !clamped ? top : coerceIn(top, 0, this.i3r_1);
    var bottom_0 = !clamped ? bottom : coerceIn(bottom, 0, this.i3r_1);
    return Companion_instance_11.p3q(this.f3r_1 + left_0 | 0, this.g3r_1 + top_0 | 0, this.f3r_1 + right_0 | 0, this.g3r_1 + bottom_0 | 0);
  }
  toString() {
    return 'Rectangle(x=' + this.f3r_1 + ', y=' + this.g3r_1 + ', width=' + this.h3r_1 + ', height=' + this.i3r_1 + ')';
  }
  z3r() {
    return Companion_getInstance_10().k3q(this.f3r_1, this.g3r_1, this.h3r_1, this.i3r_1);
  }
  k3r(border) {
    return Companion_instance_11.p3q(this.i3j() - border.t3l_1 | 0, this.d3q() - border.q3l_1 | 0, this.j3j() + border.r3l_1 | 0, this.c3q() + border.s3l_1 | 0);
  }
  hashCode() {
    var result = this.f3r_1;
    result = imul(result, 31) + this.g3r_1 | 0;
    result = imul(result, 31) + this.h3r_1 | 0;
    result = imul(result, 31) + this.i3r_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof RectangleInt))
      return false;
    var tmp0_other_with_cast = other instanceof RectangleInt ? other : THROW_CCE();
    if (!(this.f3r_1 === tmp0_other_with_cast.f3r_1))
      return false;
    if (!(this.g3r_1 === tmp0_other_with_cast.g3r_1))
      return false;
    if (!(this.h3r_1 === tmp0_other_with_cast.h3r_1))
      return false;
    if (!(this.i3r_1 === tmp0_other_with_cast.i3r_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_12 = this;
    this.a3s_1 = Scale.b3s(1.0, 1.0);
  }
}
class Scale {
  static g3q(scaleX, scaleY) {
    Companion_getInstance_12();
    var $this = createThis(this);
    $this.e3q_1 = scaleX;
    $this.f3q_1 = scaleY;
    return $this;
  }
  g3o() {
    return this.e3q_1 * 0.5 + this.f3q_1 * 0.5;
  }
  static c3s() {
    Companion_getInstance_12();
    return this.b3s(1.0, 1.0);
  }
  static d3s(scale) {
    Companion_getInstance_12();
    return this.g3q(scale, scale);
  }
  static e3s(scale) {
    Companion_getInstance_12();
    return this.d3s(scale);
  }
  static b3s(scaleX, scaleY) {
    Companion_getInstance_12();
    return this.g3q(scaleX, scaleY);
  }
  static f3s(scaleX, scaleY) {
    Companion_getInstance_12();
    return this.g3q(scaleX, scaleY);
  }
  toString() {
    return 'Scale(scaleX=' + this.e3q_1 + ', scaleY=' + this.f3q_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.e3q_1);
    result = imul(result, 31) + getNumberHashCode(this.f3q_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Scale))
      return false;
    var tmp0_other_with_cast = other instanceof Scale ? other : THROW_CCE();
    if (!equals(this.e3q_1, tmp0_other_with_cast.e3q_1))
      return false;
    if (!equals(this.f3q_1, tmp0_other_with_cast.f3q_1))
      return false;
    return true;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_13 = this;
    var tmp = this;
    tmp.j3s_1 = new ScaleMode('COVER', ScaleMode$Companion$COVER$lambda);
    var tmp_0 = this;
    tmp_0.k3s_1 = new ScaleMode('SHOW_ALL', ScaleMode$Companion$SHOW_ALL$lambda);
    var tmp_1 = this;
    tmp_1.l3s_1 = new ScaleMode('EXACT', ScaleMode$Companion$EXACT$lambda);
    var tmp_2 = this;
    tmp_2.m3s_1 = new ScaleMode('NO_SCALE', ScaleMode$Companion$NO_SCALE$lambda);
  }
  n3s() {
    return this.l3s_1;
  }
}
class ScaleMode {
  constructor(name, transform) {
    Companion_getInstance_13();
    name = name === VOID ? null : name;
    this.o3s_1 = name;
    this.p3s_1 = transform;
  }
  toString() {
    return 'ScaleMode(' + this.o3s_1 + ')';
  }
  q3s(item, container) {
    return toInt(this.p3s_1(toFloat(item), toFloat(container)));
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_14 = this;
    this.r3s_1 = Size2D.r3q(0.0, 0.0);
  }
}
class Size2D {
  static r3q(width, height) {
    Companion_getInstance_14();
    var $this = createThis(this);
    $this.u3j_1 = width;
    $this.v3j_1 = height;
    return $this;
  }
  static s3s() {
    Companion_getInstance_14();
    return this.r3q(0.0, 0.0);
  }
  static n3q(width, height) {
    Companion_getInstance_14();
    return this.r3q(width, height);
  }
  static w3j(width, height) {
    Companion_getInstance_14();
    return this.r3q(width, height);
  }
  t3s(scale) {
    return Size2D.r3q(this.u3j_1 * scale.e3q_1, this.v3j_1 * scale.f3q_1);
  }
  u3s(s) {
    return Size2D.r3q(this.u3j_1 * s, this.v3j_1 * s);
  }
  u3q(s) {
    return this.u3s(s);
  }
  g3s(other) {
    return Scale.g3q(this.u3j_1 / other.u3j_1, this.v3j_1 / other.v3j_1);
  }
  toString() {
    return 'Size(width=' + get_niceStr(this.u3j_1) + ', height=' + get_niceStr(this.v3j_1) + ')';
  }
  em() {
    return this.u3j_1;
  }
  fm() {
    return this.v3j_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.u3j_1);
    result = imul(result, 31) + getNumberHashCode(this.v3j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Size2D))
      return false;
    var tmp0_other_with_cast = other instanceof Size2D ? other : THROW_CCE();
    if (!equals(this.u3j_1, tmp0_other_with_cast.u3j_1))
      return false;
    if (!equals(this.v3j_1, tmp0_other_with_cast.v3j_1))
      return false;
    return true;
  }
}
class SizeInt {
  static x3s(width, height) {
    var $this = createThis(this);
    $this.v3s_1 = width;
    $this.w3s_1 = height;
    return $this;
  }
  static y3s() {
    return this.x3s(0, 0);
  }
  toString() {
    return '' + this.v3s_1 + 'x' + this.w3s_1;
  }
  hashCode() {
    var result = this.v3s_1;
    result = imul(result, 31) + this.w3s_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SizeInt))
      return false;
    var tmp0_other_with_cast = other instanceof SizeInt ? other : THROW_CCE();
    if (!(this.v3s_1 === tmp0_other_with_cast.v3s_1))
      return false;
    if (!(this.w3s_1 === tmp0_other_with_cast.w3s_1))
      return false;
    return true;
  }
}
class Companion_15 {
  constructor() {
    Companion_instance_15 = this;
    this.t3i_1 = Vector2D.y3k(0.0, 0.0);
    this.u3i_1 = Vector2D.y3k(NaN, NaN);
    this.v3i_1 = Vector2D.y3k(-1.0, 0.0);
    this.w3i_1 = Vector2D.y3k(+1.0, 0.0);
    this.x3i_1 = Vector2D.y3k(0.0, +1.0);
    this.y3i_1 = Vector2D.y3k(0.0, -1.0);
    this.z3i_1 = Vector2D.y3k(0.0, -1.0);
    this.a3j_1 = Vector2D.y3k(0.0, +1.0);
  }
  z3s(a, b, up) {
    // Inline function 'korlibs.math.geom.Companion.between' call
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_0();
    var x0 = a.r3i_1;
    var y0 = a.s3i_1;
    var x1 = b.r3i_1;
    var y1 = b.s3i_1;
    return Angle_between(x0, y0, x1, y1, up);
  }
  a3t(a, b, up, $super) {
    up = up === VOID ? this.x3i_1 : up;
    return $super === VOID ? this.z3s(a, b, up) : $super.z3s.call(this, a, b, up).g3i_1;
  }
  p3r(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  b3t(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  c3t(x1, y1, x2, y2) {
    // Inline function 'kotlin.math.hypot' call
    var x = x1 - x2;
    var y = y1 - y2;
    return hypot(x, y);
  }
  d3t(a, b) {
    return this.p3r(a.r3i_1, a.s3i_1, b.r3i_1, b.s3i_1);
  }
  h3k(a, b) {
    return this.e3t(a.r3i_1, a.s3i_1, b.r3i_1, b.s3i_1);
  }
  e3t(x1, y1, x2, y2) {
    return square(this, x1 - x2) + square(this, y1 - y2);
  }
  z3j(p1, p2) {
    // Inline function 'kotlin.math.min' call
    var a = p1.r3i_1;
    var b = p2.r3i_1;
    var tmp = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = p1.s3i_1;
    var b_0 = p2.s3i_1;
    var tmp$ret$1 = Math.min(a_0, b_0);
    return Vector2D.y3k(tmp, tmp$ret$1);
  }
  r3j(p1, p2, p3, p4) {
    return Vector2D.y3k(minOf(p1.r3i_1, new Float64Array([p2.r3i_1, p3.r3i_1, p4.r3i_1])), minOf(p1.s3i_1, new Float64Array([p2.s3i_1, p3.s3i_1, p4.s3i_1])));
  }
  b3k(p1, p2) {
    // Inline function 'kotlin.math.max' call
    var a = p1.r3i_1;
    var b = p2.r3i_1;
    var tmp = Math.max(a, b);
    // Inline function 'kotlin.math.max' call
    var a_0 = p1.s3i_1;
    var b_0 = p2.s3i_1;
    var tmp$ret$1 = Math.max(a_0, b_0);
    return Vector2D.y3k(tmp, tmp$ret$1);
  }
  s3j(p1, p2, p3, p4) {
    return Vector2D.y3k(maxOf(p1.r3i_1, new Float64Array([p2.r3i_1, p3.r3i_1, p4.r3i_1])), maxOf(p1.s3i_1, new Float64Array([p2.s3i_1, p3.s3i_1, p4.s3i_1])));
  }
}
class Vector2D {
  static y3k(x, y) {
    Companion_getInstance_15();
    var $this = createThis(this);
    $this.r3i_1 = x;
    $this.s3i_1 = y;
    return $this;
  }
  static m3q(x, y) {
    Companion_getInstance_15();
    return this.y3k(x, y);
  }
  static k3l(x, y) {
    Companion_getInstance_15();
    return this.y3k(x, y);
  }
  static i3l() {
    Companion_getInstance_15();
    return this.y3k(0.0, 0.0);
  }
  i3s() {
    // Inline function 'kotlin.math.min' call
    var a = this.r3i_1;
    var b = this.s3i_1;
    return Math.min(a, b);
  }
  h3s() {
    // Inline function 'kotlin.math.max' call
    var a = this.r3i_1;
    var b = this.s3i_1;
    return Math.max(a, b);
  }
  f3t(x, y) {
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this.r3i_1;
    var y_0 = y - this.s3i_1;
    return hypot(x_0, y_0);
  }
  g3t(that) {
    return this.f3t(that.r3i_1, that.s3i_1);
  }
  a() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.r3i_1;
    var y = this.s3i_1;
    return hypot(x, y);
  }
  h3t() {
    var x = this.r3i_1;
    var y = this.s3i_1;
    return x * x + y * y;
  }
  i3t() {
    // Inline function 'kotlin.math.hypot' call
    var x = this.r3i_1;
    var y = this.s3i_1;
    return hypot(x, y);
  }
  j3t() {
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var scale = 1.0 / this.i3t();
    return Vector2D.y3k(this.r3i_1 * scale, this.s3i_1 * scale);
  }
  k3t() {
    return Vector2D.y3k(-this.s3i_1, this.r3i_1);
  }
  l3t(other, epsilon) {
    return isAlmostEquals(this.r3i_1, other.r3i_1, epsilon) && isAlmostEquals(this.s3i_1, other.s3i_1, epsilon);
  }
  f27(other, epsilon) {
    return this.l3t(other instanceof Vector2D ? other : THROW_CCE(), epsilon);
  }
  m3t() {
    return '(' + get_niceStr(this.r3i_1) + ', ' + get_niceStr(this.s3i_1) + ')';
  }
  toString() {
    return this.m3t();
  }
  em() {
    return this.r3i_1;
  }
  fm() {
    return this.s3i_1;
  }
  hashCode() {
    var result = getNumberHashCode(this.r3i_1);
    result = imul(result, 31) + getNumberHashCode(this.s3i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2D))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2D ? other : THROW_CCE();
    if (!equals(this.r3i_1, tmp0_other_with_cast.r3i_1))
      return false;
    if (!equals(this.s3i_1, tmp0_other_with_cast.s3i_1))
      return false;
    return true;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_16 = this;
    this.n3t_1 = new Vector3F(NaN, NaN, NaN);
    this.o3t_1 = new Vector3F(0.0, 0.0, 0.0);
    this.p3t_1 = new Vector3F(1.0, 1.0, 1.0);
    this.q3t_1 = new Vector3F(0.0, 0.0, 1.0);
    this.r3t_1 = new Vector3F(0.0, 0.0, -1.0);
    this.s3t_1 = new Vector3F(-1.0, 0.0, 0.0);
    this.t3t_1 = new Vector3F(1.0, 0.0, 0.0);
    this.u3t_1 = new Vector3F(0.0, 1.0, 0.0);
    this.v3t_1 = new Vector3F(0.0, -1.0, 0.0);
  }
}
class Vector3F {
  constructor(x, y, z) {
    Companion_getInstance_16();
    this.w3t_1 = x;
    this.x3t_1 = y;
    this.y3t_1 = z;
  }
  z3t(other) {
    var dx = this.w3t_1 - other.w3t_1;
    var dy = this.x3t_1 - other.x3t_1;
    var dz = this.y3t_1 - other.y3t_1;
    // Inline function 'kotlin.math.sqrt' call
    var x = dx * dx + dy * dy + dz * dz;
    return Math.sqrt(x);
  }
  toString() {
    return 'Vector3(' + get_niceStr_0(this.w3t_1) + ', ' + get_niceStr_0(this.x3t_1) + ', ' + get_niceStr_0(this.y3t_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.w3t_1);
    result = imul(result, 31) + getNumberHashCode(this.x3t_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y3t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector3F))
      return false;
    var tmp0_other_with_cast = other instanceof Vector3F ? other : THROW_CCE();
    if (!equals(this.w3t_1, tmp0_other_with_cast.w3t_1))
      return false;
    if (!equals(this.x3t_1, tmp0_other_with_cast.x3t_1))
      return false;
    if (!equals(this.y3t_1, tmp0_other_with_cast.y3t_1))
      return false;
    return true;
  }
}
class Companion_17 {
  constructor() {
    Companion_instance_17 = this;
    this.a3u_1 = Vector2I.v3r(0, 0);
  }
}
class Vector2I {
  static v3r(x, y) {
    Companion_getInstance_17();
    var $this = createThis(this);
    $this.s3r_1 = x;
    $this.t3r_1 = y;
    return $this;
  }
  static b3u() {
    Companion_getInstance_17();
    return this.v3r(0, 0);
  }
  u3r(that) {
    return Vector2I.v3r(this.s3r_1 - that.s3r_1 | 0, this.t3r_1 - that.t3r_1 | 0);
  }
  toString() {
    return '(' + this.s3r_1 + ', ' + this.t3r_1 + ')';
  }
  hashCode() {
    var result = this.s3r_1;
    result = imul(result, 31) + this.t3r_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Vector2I))
      return false;
    var tmp0_other_with_cast = other instanceof Vector2I ? other : THROW_CCE();
    if (!(this.s3r_1 === tmp0_other_with_cast.s3r_1))
      return false;
    if (!(this.t3r_1 === tmp0_other_with_cast.t3r_1))
      return false;
    return true;
  }
}
//endregion
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function _Angle___init__impl__g23q1m(radians) {
  return radians;
}
function _Angle___get_radians__impl__n00yt5($this) {
  return $this;
}
function _Angle___get_ratio__impl__ap3on4($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToRatio' call
  Companion_getInstance_0();
  var radians = _Angle___get_radians__impl__n00yt5($this);
  return _Ratio___init__impl__9mwvn2(radians / 6.283185307179586);
}
function _Angle___get_degrees__impl__qg56vw($this) {
  // Inline function 'korlibs.math.geom.Companion.radiansToDegrees' call
  Companion_getInstance_0();
  return _Angle___get_radians__impl__n00yt5($this) * 57.29577951308232;
}
function _Angle___get_cosine__impl__vprvmu($this) {
  // Inline function 'kotlin.math.cos' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.cos(x);
}
function _Angle___get_sine__impl__15nmyi($this) {
  // Inline function 'kotlin.math.sin' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.sin(x);
}
function _Angle___get_tangent__impl__vushdy($this) {
  // Inline function 'kotlin.math.tan' call
  var x = _Angle___get_radians__impl__n00yt5($this);
  return Math.tan(x);
}
function Angle__cosine_impl_bgvzun($this, up) {
  return _Angle___get_cosine__impl__vprvmu(adjustFromUp($this, up));
}
function Angle__sine_impl_3l11xv($this, up) {
  return _Angle___get_sine__impl__15nmyi(adjustFromUp($this, up));
}
function _Angle___get_absoluteValue__impl__4qoakv($this) {
  // Inline function 'kotlin.math.absoluteValue' call
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var this_0 = _Angle___get_radians__impl__n00yt5($this);
  var tmp$ret$1 = Math.abs(this_0);
  return _Angle___init__impl__g23q1m(tmp$ret$1);
}
function Angle__div_impl_ut2btd($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 / scale);
}
function Angle__times_impl_v3s9y2($this, scale) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(tmp$ret$0 * scale);
}
function Angle__div_impl_ut2btd_0($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  return tmp / _Angle___get_radians__impl__n00yt5(other);
}
function Angle__plus_impl_26v37k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp + tmp$ret$1);
}
function Angle__minus_impl_xeau7k($this, other) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp = _Angle___get_radians__impl__n00yt5($this);
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$1 = _Angle___get_radians__impl__n00yt5(other);
  return _Angle___init__impl__g23q1m(tmp - tmp$ret$1);
}
function Angle__unaryMinus_impl_7901fr($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(-tmp$ret$0);
}
function Angle__unaryPlus_impl_eyi5pl($this) {
  // Inline function 'korlibs.math.geom.Angle.internal' call
  var tmp$ret$0 = _Angle___get_radians__impl__n00yt5($this);
  return _Angle___init__impl__g23q1m(+tmp$ret$0);
}
function Angle__isAlmostEquals_impl_201sgt($this, other, epsilon) {
  return isAlmostEquals(_Angle___get_radians__impl__n00yt5($this), _Angle___get_radians__impl__n00yt5(other), epsilon);
}
function Angle__isAlmostEquals_impl_201sgt_0($this, other, epsilon) {
  return Angle__isAlmostEquals_impl_201sgt($this.g3i_1, other instanceof Angle ? other.g3i_1 : THROW_CCE(), epsilon);
}
function _Angle___get_normalized__impl__9s30ys($this) {
  // Inline function 'korlibs.math.geom.Companion.fromRatio' call
  Companion_getInstance_0();
  var ratio = umod(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4($this)), 1.0);
  // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
  var ratio_0 = toRatio(ratio);
  var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function Angle__compareTo_impl_a0hfds($this, other) {
  return Ratio__compareTo_impl_z2ienc(_Angle___get_ratio__impl__ap3on4($this), _Angle___get_ratio__impl__ap3on4(other));
}
function Angle__compareTo_impl_a0hfds_0($this, other) {
  return Angle__compareTo_impl_a0hfds($this.g3i_1, other instanceof Angle ? other.g3i_1 : THROW_CCE());
}
function Angle__toString_impl_786qky($this) {
  return get_niceStr(roundDecimalPlaces(_Angle___get_degrees__impl__qg56vw($this), 2)) + '.degrees';
}
var Companion_instance_0;
function Companion_getInstance_0() {
  if (Companion_instance_0 === VOID)
    new Companion_0();
  return Companion_instance_0;
}
function Angle__hashCode_impl_szcndt($this) {
  return getNumberHashCode($this);
}
function Angle__equals_impl_zcf5mt($this, other) {
  if (!(other instanceof Angle))
    return false;
  var tmp0_other_with_cast = other instanceof Angle ? other.g3i_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_degrees(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromDegrees' call
  // Inline function 'korlibs.math.geom.Companion.degreesToRadians' call
  Companion_getInstance_0();
  var tmp$ret$0 = _this__u8e3s4 * 0.017453292519943295;
  return _Angle___init__impl__g23q1m(tmp$ret$0);
}
function get_radians(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function get_radians_0(_this__u8e3s4) {
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  Companion_getInstance_0();
  return _Angle___init__impl__g23q1m(_this__u8e3s4);
}
function adjustFromUp(_this__u8e3s4, up) {
  Companion_instance_9.q3i(up);
  return up.s3i_1 > 0 ? _this__u8e3s4 : Angle__unaryMinus_impl_7901fr(_this__u8e3s4);
}
function Angle_between(x0, y0, x1, y1, up) {
  up = up === VOID ? Companion_getInstance_15().x3i_1 : up;
  // Inline function 'korlibs.math.geom.Companion.atan2' call
  Companion_getInstance_0();
  var x = y1 - y0;
  var y = x1 - x0;
  var up_0 = Companion_getInstance_15().x3i_1;
  // Inline function 'korlibs.math.geom.Companion.fromRadians' call
  // Inline function 'kotlin.math.atan2' call
  var radians = Math.atan2(x, y);
  var tmp$ret$1 = _Angle___init__impl__g23q1m(radians);
  var angle = adjustFromUp(tmp$ret$1, up_0);
  return adjustFromUp(Angle__compareTo_impl_a0hfds(angle, Companion_getInstance_0().i3i_1) < 0 ? Angle__plus_impl_26v37k(angle, Companion_getInstance_0().m3i_1) : angle, up);
}
function _BoundsBuilder___init__impl__g6dprh(bounds) {
  return bounds;
}
function _BoundsBuilder___get_bounds__impl__s1l1gx($this) {
  return $this;
}
function _BoundsBuilder___get_isEmpty__impl__e9t785($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).g3j();
}
function _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this) {
  return _BoundsBuilder___get_bounds__impl__s1l1gx($this).h3j();
}
function _BoundsBuilder___get_xmin__impl__o2sib0($this) {
  // Inline function 'kotlin.math.min' call
  var a = _BoundsBuilder___get_bounds__impl__s1l1gx($this).i3j();
  var b = _BoundsBuilder___get_bounds__impl__s1l1gx($this).j3j();
  return Math.min(a, b);
}
function BoundsBuilder__xminOr_impl_k3l1m2($this, default_0) {
  return _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) ? _BoundsBuilder___get_xmin__impl__o2sib0($this) : default_0;
}
function _BoundsBuilder___get_hasPoints__impl__6mwi9x($this) {
  return _BoundsBuilder___get_isNotEmpty__impl__w6rbsy($this);
}
var Companion_instance_1;
function Companion_getInstance_1() {
  if (Companion_instance_1 === VOID)
    new Companion_1();
  return Companion_instance_1;
}
function BoundsBuilder__plus_impl_cz7f7x($this, p) {
  if (_BoundsBuilder___get_bounds__impl__s1l1gx($this).g3j())
    return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_10().x3j(p, Size2D.w3j(0, 0)));
  return _BoundsBuilder___init__impl__g6dprh(Companion_getInstance_10().t3j(Companion_getInstance_15().z3j(_BoundsBuilder___get_bounds__impl__s1l1gx($this).y3j(), p), Companion_getInstance_15().b3k(_BoundsBuilder___get_bounds__impl__s1l1gx($this).a3k(), p)));
}
function BoundsBuilder__plus_impl_cz7f7x_0($this, rect) {
  if (rect == null)
    return $this;
  if (rect.g3j())
    return $this;
  return BoundsBuilder__plus_impl_cz7f7x(BoundsBuilder__plus_impl_cz7f7x($this, rect.y3j()), rect.a3k());
}
function BoundsBuilder__boundsOrNull_impl_se9lyg($this) {
  return _BoundsBuilder___get_isEmpty__impl__e9t785($this) ? null : _BoundsBuilder___get_bounds__impl__s1l1gx($this);
}
function BoundsBuilder__toString_impl_fmvxh7($this) {
  return 'BoundsBuilder(bounds=' + $this.toString() + ')';
}
function BoundsBuilder__hashCode_impl_649zbo($this) {
  return $this.hashCode();
}
function BoundsBuilder__equals_impl_jngfjs($this, other) {
  if (!(other instanceof BoundsBuilder))
    return false;
  var tmp0_other_with_cast = other instanceof BoundsBuilder ? other.c3k_1 : THROW_CCE();
  if (!$this.equals(tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_2;
function Companion_getInstance_2() {
  return Companion_instance_2;
}
var Companion_instance_3;
function Companion_getInstance_3() {
  return Companion_instance_3;
}
var Companion_instance_4;
function Companion_getInstance_4() {
  if (Companion_instance_4 === VOID)
    new Companion_4();
  return Companion_instance_4;
}
var Companion_instance_5;
function Companion_getInstance_5() {
  if (Companion_instance_5 === VOID)
    new Companion_5();
  return Companion_instance_5;
}
var Companion_instance_6;
function Companion_getInstance_6() {
  if (Companion_instance_6 === VOID)
    new Companion_6();
  return Companion_instance_6;
}
var MatrixType_IDENTITY_instance;
var MatrixType_TRANSLATE_instance;
var MatrixType_SCALE_instance;
var MatrixType_SCALE_TRANSLATE_instance;
var MatrixType_COMPLEX_instance;
var MatrixType_entriesInitialized;
function MatrixType_initEntries() {
  if (MatrixType_entriesInitialized)
    return Unit_instance;
  MatrixType_entriesInitialized = true;
  MatrixType_IDENTITY_instance = new MatrixType('IDENTITY', 0, 1, false, false, false);
  MatrixType_TRANSLATE_instance = new MatrixType('TRANSLATE', 1, 2, false, false, true);
  MatrixType_SCALE_instance = new MatrixType('SCALE', 2, 3, false, true, false);
  MatrixType_SCALE_TRANSLATE_instance = new MatrixType('SCALE_TRANSLATE', 3, 4, false, true, true);
  MatrixType_COMPLEX_instance = new MatrixType('COMPLEX', 4, 5, true, true, true);
}
var Companion_instance_7;
function Companion_getInstance_7() {
  if (Companion_instance_7 === VOID)
    new Companion_7();
  return Companion_instance_7;
}
function MatrixType_IDENTITY_getInstance() {
  MatrixType_initEntries();
  return MatrixType_IDENTITY_instance;
}
function MatrixType_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_TRANSLATE_instance;
}
function MatrixType_SCALE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_instance;
}
function MatrixType_SCALE_TRANSLATE_getInstance() {
  MatrixType_initEntries();
  return MatrixType_SCALE_TRANSLATE_instance;
}
function MatrixType_COMPLEX_getInstance() {
  MatrixType_initEntries();
  return MatrixType_COMPLEX_instance;
}
var Companion_instance_8;
function Companion_getInstance_8() {
  if (Companion_instance_8 === VOID)
    new Companion_8();
  return Companion_instance_8;
}
function ortho(_this__u8e3s4, rect, near, far) {
  near = near === VOID ? 0.0 : near;
  far = far === VOID ? 1.0 : far;
  return Companion_getInstance_8().y3p(rect.i3j(), rect.j3j(), rect.c3q(), rect.d3q(), near, far);
}
function scaled(_this__u8e3s4, scale) {
  return _this__u8e3s4.x3m(scale.e3q_1, scale.f3q_1);
}
function get_scale(_this__u8e3s4) {
  return Scale.g3q(_this__u8e3s4.w3n_1, _this__u8e3s4.x3n_1);
}
var Orientation_CLOCK_WISE_instance;
var Orientation_COUNTER_CLOCK_WISE_instance;
var Orientation_COLLINEAR_instance;
var Companion_instance_9;
function Companion_getInstance_9() {
  return Companion_instance_9;
}
var Orientation_entriesInitialized;
function Orientation_initEntries() {
  if (Orientation_entriesInitialized)
    return Unit_instance;
  Orientation_entriesInitialized = true;
  Orientation_CLOCK_WISE_instance = new Orientation('CLOCK_WISE', 0, 1);
  Orientation_COUNTER_CLOCK_WISE_instance = new Orientation('COUNTER_CLOCK_WISE', 1, -1);
  Orientation_COLLINEAR_instance = new Orientation('COLLINEAR', 2, 0);
}
var Companion_instance_10;
function Companion_getInstance_10() {
  if (Companion_instance_10 === VOID)
    new Companion_10();
  return Companion_instance_10;
}
function outerCircle(_this__u8e3s4) {
  var centerX = _this__u8e3s4.y3q();
  var centerY = _this__u8e3s4.z3q();
  return new Circle(_this__u8e3s4.a3r(), Companion_getInstance_15().p3r(centerX, centerY, _this__u8e3s4.j3j(), _this__u8e3s4.d3q()));
}
var Companion_instance_11;
function Companion_getInstance_11() {
  return Companion_instance_11;
}
var Companion_instance_12;
function Companion_getInstance_12() {
  if (Companion_instance_12 === VOID)
    new Companion_12();
  return Companion_instance_12;
}
function toVector2(_this__u8e3s4) {
  return Vector2D.y3k(_this__u8e3s4.e3q_1, _this__u8e3s4.f3q_1);
}
function ScaleMode$Companion$COVER$lambda(i, c) {
  return i.u3q(toVector2(c.g3s(i)).h3s());
}
function ScaleMode$Companion$SHOW_ALL$lambda(i, c) {
  return i.u3q(toVector2(c.g3s(i)).i3s());
}
function ScaleMode$Companion$EXACT$lambda(i, c) {
  return c;
}
function ScaleMode$Companion$NO_SCALE$lambda(i, c) {
  return i;
}
var Companion_instance_13;
function Companion_getInstance_13() {
  if (Companion_instance_13 === VOID)
    new Companion_13();
  return Companion_instance_13;
}
var Companion_instance_14;
function Companion_getInstance_14() {
  if (Companion_instance_14 === VOID)
    new Companion_14();
  return Companion_instance_14;
}
function toFloat(_this__u8e3s4) {
  return Size2D.n3q(_this__u8e3s4.v3s_1, _this__u8e3s4.w3s_1);
}
function toInt(_this__u8e3s4) {
  return SizeInt.x3s(numberToInt(_this__u8e3s4.u3j_1), numberToInt(_this__u8e3s4.v3j_1));
}
function toSize(_this__u8e3s4) {
  return Size2D.r3q(_this__u8e3s4.r3i_1, _this__u8e3s4.s3i_1);
}
function transformX(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.g3j()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.y3k(m.r3m(_this__u8e3s4.r3i_1, _this__u8e3s4.s3i_1), m.u3m(_this__u8e3s4.r3i_1, _this__u8e3s4.s3i_1));
  }
  return tmp$ret$0.r3i_1;
}
function transformY(_this__u8e3s4, m) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    if (m.g3j()) {
      tmp$ret$0 = _this__u8e3s4;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.y3k(m.r3m(_this__u8e3s4.r3i_1, _this__u8e3s4.s3i_1), m.u3m(_this__u8e3s4.r3i_1, _this__u8e3s4.s3i_1));
  }
  return tmp$ret$0.s3i_1;
}
function square($this, x) {
  return x * x;
}
var Companion_instance_15;
function Companion_getInstance_15() {
  if (Companion_instance_15 === VOID)
    new Companion_15();
  return Companion_instance_15;
}
function toInt_0(_this__u8e3s4) {
  return Vector2I.v3r(numberToInt(_this__u8e3s4.r3i_1), numberToInt(_this__u8e3s4.s3i_1));
}
var Companion_instance_16;
function Companion_getInstance_16() {
  if (Companion_instance_16 === VOID)
    new Companion_16();
  return Companion_instance_16;
}
var Companion_instance_17;
function Companion_getInstance_17() {
  if (Companion_instance_17 === VOID)
    new Companion_17();
  return Companion_instance_17;
}
function interpolate_0(_this__u8e3s4, l, r) {
  return Vector2D.y3k(interpolate(_this__u8e3s4, l.r3i_1, r.r3i_1), interpolate(_this__u8e3s4, l.s3i_1, r.s3i_1));
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(Anchor2D, 'Anchor2D');
initMetadataForCompanion(Companion_0);
protoOf(Angle).g27 = isAlmostEquals$default;
initMetadataForClass(Angle, 'Angle', VOID, VOID, [Comparable, IsAlmostEquals]);
initMetadataForCompanion(Companion_1);
initMetadataForClass(BoundsBuilder, 'BoundsBuilder');
initMetadataForCompanion(Companion_2);
initMetadataForClass(Circle, 'Circle');
initMetadataForClass(IPointList$Sublist$listIterator$1);
initMetadataForClass(Sublist, 'Sublist', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_3);
initMetadataForInterface(IDoubleVectorList, 'IDoubleVectorList', VOID, VOID, [IsAlmostEquals]);
initMetadataForInterface(IPointList, 'IPointList', VOID, VOID, [IDoubleVectorList, KtList]);
initMetadataForCompanion(Companion_4);
initMetadataForClass(Line2D, 'Line2D', Line2D.h3l);
initMetadataForCompanion(Companion_5);
initMetadataForClass(MarginInt, 'MarginInt');
initMetadataForCompanion(Companion_6);
protoOf(Matrix).g27 = isAlmostEquals$default;
initMetadataForClass(Matrix, 'Matrix', VOID, VOID, [IsAlmostEquals]);
initMetadataForClass(MatrixType, 'MatrixType');
initMetadataForCompanion(Companion_7);
protoOf(MatrixTransform).g27 = isAlmostEquals$default;
initMetadataForClass(MatrixTransform, 'MatrixTransform', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_8);
initMetadataForClass(Matrix4, 'Matrix4', Matrix4.d3p);
initMetadataForCompanion(Companion_9);
initMetadataForClass(Orientation, 'Orientation');
initMetadataForCompanion(Companion_10);
protoOf(Rectangle).g27 = isAlmostEquals$default;
initMetadataForClass(Rectangle, 'Rectangle', VOID, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(RectangleInt, 'RectangleInt', RectangleInt.w3r);
initMetadataForCompanion(Companion_12);
initMetadataForClass(Scale, 'Scale', Scale.c3s);
initMetadataForCompanion(Companion_13);
initMetadataForClass(ScaleMode, 'ScaleMode');
initMetadataForCompanion(Companion_14);
initMetadataForClass(Size2D, 'Size2D', Size2D.s3s);
initMetadataForClass(SizeInt, 'SizeInt', SizeInt.y3s);
initMetadataForCompanion(Companion_15);
protoOf(Vector2D).g27 = isAlmostEquals$default;
initMetadataForClass(Vector2D, 'Vector2D', Vector2D.i3l, VOID, [IsAlmostEquals]);
initMetadataForCompanion(Companion_16);
initMetadataForClass(Vector3F, 'Vector3F');
initMetadataForCompanion(Companion_17);
initMetadataForClass(Vector2I, 'Vector2I', Vector2I.b3u);
//endregion
//region block: init
Companion_instance_2 = new Companion_2();
Companion_instance_3 = new Companion_3();
Companion_instance_9 = new Companion_9();
Companion_instance_11 = new Companion_11();
//endregion
//region block: exports
export {
  MatrixType_IDENTITY_getInstance as MatrixType_IDENTITY_getInstance26n3n49ggvwm4,
  _Angle___init__impl__g23q1m as _Angle___init__impl__g23q1m36yxttgnpy5tv,
  _Angle___get_absoluteValue__impl__4qoakv as _Angle___get_absoluteValue__impl__4qoakv4cdwg294ssle,
  Angle__compareTo_impl_a0hfds as Angle__compareTo_impl_a0hfds24obl4qqhxk1t,
  _Angle___get_cosine__impl__vprvmu as _Angle___get_cosine__impl__vprvmu3ab5uwcliuboq,
  _Angle___get_degrees__impl__qg56vw as _Angle___get_degrees__impl__qg56vw2n539uvc01e1n,
  Angle__div_impl_ut2btd as Angle__div_impl_ut2btd1qmy7ftoy1opp,
  Angle__div_impl_ut2btd_0 as Angle__div_impl_ut2btd19ndx9mxcgcss,
  Angle__hashCode_impl_szcndt as Angle__hashCode_impl_szcndtx0rhatnvuhb1,
  Angle__minus_impl_xeau7k as Angle__minus_impl_xeau7ko02ca30grn4a,
  _Angle___get_normalized__impl__9s30ys as _Angle___get_normalized__impl__9s30ys1q15xt9x23bx,
  Angle__plus_impl_26v37k as Angle__plus_impl_26v37karx983dsduoy,
  _Angle___get_radians__impl__n00yt5 as _Angle___get_radians__impl__n00yt518seywpfbf9fr,
  _Angle___get_ratio__impl__ap3on4 as _Angle___get_ratio__impl__ap3on435dv91f5cbp85,
  _Angle___get_sine__impl__15nmyi as _Angle___get_sine__impl__15nmyi39oh4tio4auz1,
  _Angle___get_tangent__impl__vushdy as _Angle___get_tangent__impl__vushdy2zy6w59e4l7qg,
  Angle__times_impl_v3s9y2 as Angle__times_impl_v3s9y21yznxo5bj1uj7,
  Angle__unaryMinus_impl_7901fr as Angle__unaryMinus_impl_7901fruk5m76f5kg06,
  Angle__unaryPlus_impl_eyi5pl as Angle__unaryPlus_impl_eyi5plrfyn5fslhvdp,
  _BoundsBuilder___get_bounds__impl__s1l1gx as _BoundsBuilder___get_bounds__impl__s1l1gx2fs31mzomv5i,
  BoundsBuilder__boundsOrNull_impl_se9lyg as BoundsBuilder__boundsOrNull_impl_se9lyg1z0iqowyff423,
  BoundsBuilder__hashCode_impl_649zbo as BoundsBuilder__hashCode_impl_649zbo2cbmgnd4y2see,
  BoundsBuilder__plus_impl_cz7f7x as BoundsBuilder__plus_impl_cz7f7xocbq7jeozma3,
  BoundsBuilder__plus_impl_cz7f7x_0 as BoundsBuilder__plus_impl_cz7f7xm06pofb9kabm,
  BoundsBuilder__toString_impl_fmvxh7 as BoundsBuilder__toString_impl_fmvxh7qh65bafrb2p,
  BoundsBuilder__xminOr_impl_k3l1m2 as BoundsBuilder__xminOr_impl_k3l1m233j5xey4uzzri,
  Companion_getInstance as Companion_getInstanceeqp3ibr2vvu9,
  Companion_getInstance_0 as Companion_getInstance3rze5babd97ff,
  Companion_getInstance_1 as Companion_getInstance2yu48324co92b,
  Companion_getInstance_5 as Companion_getInstancenbeyvbsm21qs,
  Companion_getInstance_6 as Companion_getInstance1zxby1ngivg0d,
  Companion_getInstance_8 as Companion_getInstance3qti4zygy7usz,
  Companion_getInstance_10 as Companion_getInstance1bdwtq6rroayu,
  Companion_instance_11 as Companion_instanceu31qrc8c1r0r,
  Companion_getInstance_13 as Companion_getInstance23o88a0u6ly94,
  Companion_getInstance_14 as Companion_getInstance1j5nd3fbu9uao,
  Companion_getInstance_15 as Companion_getInstancewdpvtc2ehxkt,
  Companion_getInstance_16 as Companion_getInstance1yq7a1f60lp2k,
  Anchor2D as Anchor2D3ucppq7m9n3z8,
  Angle_between as Angle_between72970e1vlen9,
  Angle as Angle2itorpob18n08,
  BoundsBuilder as BoundsBuilder162uwsje56mvu,
  isAlmostEquals_0 as isAlmostEquals2qd88bwpjj4z5,
  IDoubleVectorList as IDoubleVectorListoa05cse3he2p,
  containsAll as containsAll194lepx84fvib,
  iterator as iterator1sm8hwbj0nmg8,
  listIterator as listIteratorrk3szyua4uzm,
  listIterator_0 as listIterator3ooh2yjav3kr9,
  subList as subList2funs4qwcrhhq,
  IPointList as IPointListz7raskb2mrxa,
  Line2D as Line2D2pf35pcx71ncp,
  MarginInt as MarginInt3jiec8xsxkfd,
  Matrix4 as Matrix43neeu8v4zk4i7,
  MatrixTransform as MatrixTransform1wlsrhxt7473v,
  Matrix as Matrix1p940sdz227jj,
  RectangleInt as RectangleInt3lmu13ytuf5lk,
  Rectangle as Rectangle3q03woyn9k8x1,
  Scale as Scale2cm697xlulcp5,
  Size2D as Size2Dum5ayuyhhau7,
  SizeInt as SizeInte6w85oa6mz6v,
  Vector2D as Vector2D378fe5rov8fgw,
  Vector2I as Vector2I2k5512l4eeahb,
  get_degrees as get_degrees3czcd4ojw4i,
  ortho as orthow9c0o91bw54n,
  outerCircle as outerCircle30hn5vvbpz9gu,
  get_scale as get_scale17gmsnxnqj6j9,
  scaled as scaled2eehd42i2trq9,
  toFloat as toFloat3b315y36g90cd,
  toInt as toIntp2twe4onfbic,
  toInt_0 as toIntu0rc68akxu7a,
  transformX as transformX33nszy4vzqsfy,
  transformY as transformY3ktoxhxwkzwk1,
  interpolate_0 as interpolatewhd2sgxffql5,
};
//endregion
